import {Toast} from "vant";

/**
 * 获取秒级时间戳
 * @returns {number}
 */
export function gettime(){
    return parseInt(new Date().getTime() / 1000);
}

/**
 *  判断是否在ios设备上
 */
export function onIos(){
    var u = navigator.userAgent;
    var ua = u.toLowerCase();
    if (/iphone|ipad|ipod/.test(ua)) {  // iOS 系统 ->  跳AppStore下载地址
        //alert("iOS");
        return true;
    }
    return false;
}

/**
 * 获取urlquery参数
 * @param name
 * @param url
 * @returns {string|null}
 */
export function getUrlKey(name,url = window.location.href){
    return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(url) || [, ""])[1].replace(/\+/g, '%20')) || null

}
export const processRequest = (promise, success, fail) => {
    promise.then(({ status, data, errMsg }) => {
        if(status === 1) {
            success && success(data)
        } else {
            Toast(errMsg)
        }
    })
}
